import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-noir text-cream p-6 text-center">
          <p className="font-mono text-gold text-xs tracking-widest mb-4">COURT ADJOURNED UNEXPECTEDLY</p>
          <p className="font-serif text-2xl mb-2">Sustained. Something broke.</p>
          <p className="text-gray2 text-sm mb-6 max-w-md">{String(this.state.error)}</p>
          <a href="/" className="bg-oxblood hover:opacity-90 text-cream px-5 py-2.5 text-sm rounded-md">Reopen court</a>
        </div>
      );
    }
    return this.props.children;
  }
}
